// Dish Tech React
import {getStore} from '@dishtech-react/redux';

// Configs
import {formConfig} from '../../config/form-config';
import {serviceConfig} from '../../config/service-config';

const [store, history] = getStore({formConfig, serviceConfig});

export {history};
export default store;
